import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import download from 'downloadjs';
import Loading from '../common/Loading';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 16px;
  width: 1024px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: fadeIn 0.2s ease;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 768px) {
    width: 96vw;
    height: 85vh;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`;

const BtnGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ $primary }) => ($primary ? '#333' : '#f3f4f6')};
  color: ${({ $primary }) => ($primary ? '#fff' : '#374151')};
  &:hover {
    background: ${({ $primary }) => ($primary ? '#111' : '#e5e7eb')};
  }
`;

const CloseBtn = styled.div`
  cursor: pointer;
  color: #6b7280;
  font-size: 22px;
  display: flex;
  &:hover { color: #111827; }
`;

const IframeWrap = styled.div`
  flex: 1;
  overflow: hidden;
  border-radius: 0 0 16px 16px;
`;

const PdfPreviewModal = ({ userId, orderId, orderIdStr, onClose }) => {
  const [pdfSrc, setPdfSrc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const { data } = await axios.get(`/api/orders/orderlist/download/${userId}/${orderId}`);
        setPdfSrc(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPdf();
  }, [userId, orderId]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handlePrint = () => {
    if (!pdfSrc) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.write(
      `<html><head><title>발주서 인쇄</title></head><body style="margin:0">` +
      `<iframe src="${pdfSrc}" style="width:100%;height:100%;border:none" onload="this.contentWindow.focus();this.contentWindow.print();"></iframe>` +
      `</body></html>`
    );
    printWindow.document.close();
  };

  const handleDownload = () => {
    if (pdfSrc) {
      download(pdfSrc, `슈퍼트랙_발주서_${orderIdStr}.pdf`, 'application/pdf');
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalBox>
        <Header>
          <Title>발주서 - {orderIdStr}</Title>
          <BtnGroup>
            <ActionBtn onClick={handlePrint}>인쇄</ActionBtn>
            <ActionBtn $primary onClick={handleDownload}>저장</ActionBtn>
            <CloseBtn onClick={onClose}>&times;</CloseBtn>
          </BtnGroup>
        </Header>
        <IframeWrap>
          {loading ? (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Loading />
            </div>
          ) : pdfSrc ? (
            <iframe
              id="pdf-preview-iframe"
              src={pdfSrc}
              title="발주서 미리보기"
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          ) : (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
              PDF를 불러올 수 없습니다.
            </div>
          )}
        </IframeWrap>
      </ModalBox>
    </Overlay>
  );
};

export default PdfPreviewModal;
